export enum EValidationStatus {
  None = 0,
  Invalid = 1,
  Valid = 2,
}
